import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Auth
      "login": "Login",
      "register": "Register",
      "email": "Email",
      "password": "Password",
      "name": "Name",
      "role": "Role",
      "teacher": "Trainer",
      "student": "Trainee",
      "logout": "Logout",
      "welcomeBack": "Welcome Back",
      "createAccount": "Create Account",
      "alreadyHaveAccount": "Already have an account?",
      "dontHaveAccount": "Don't have an account?",
      
      // Dashboard
      "dashboard": "Dashboard",
      "questionBank": "Question Bank",
      "exams": "Exams",
      "myExams": "My Exams",
      "results": "Results",
      "myResults": "My Results",
      
      // Questions
      "addQuestion": "Add Question",
      "uploadQuestions": "Upload Questions",
      "questionText": "Question Text",
      "optionA": "Option A",
      "optionB": "Option B",
      "optionC": "Option C",
      "optionD": "Option D",
      "correctAnswer": "Correct Answer",
      "category": "Category",
      "difficulty": "Difficulty",
      "easy": "Easy",
      "medium": "Medium",
      "hard": "Hard",
      "save": "Save",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Delete",
      "search": "Search",
      "filter": "Filter",
      "totalQuestions": "Total Questions",
      "uploadFile": "Upload File",
      "dragDropFile": "Drag and drop file here, or click to select",
      "supportsExcelCSV": "Supports Excel (.xlsx, .xls) and CSV files",
      
      // Exams
      "createExam": "Create Exam",
      "examTitle": "Exam Title",
      "duration": "Duration (minutes)",
      "generateExam": "Generate Exam",
      "takeExam": "Take Exam",
      "viewResults": "View Results",
      "submit": "Submit",
      "examsList": "Exams List",
      "availableExams": "Available Exams",
      "noExamsAvailable": "No exams available",
      "questionsCount": "questions",
      "minutes": "minutes",
      "numberOfQuestions": "Number of Questions",
      "editExam": "Edit Exam",
      "examUpdated": "Exam updated successfully",
      "downloadPDF": "Download PDF",
      "pdfDownloaded": "PDF downloaded successfully",
      "editQuestions": "Edit Questions",
      "saveChanges": "Save Changes",
      "appName": "Shamah",
      "appFullName": "Shamah Testing Platform",
      "addTrainer": "Add Trainer",
      "exportData": "Export Data",
      "downloadSubmissions": "Download Submissions",
      "downloadPendingExams": "Download Pending Exams",
      "studentName": "Student Name",
      "studentEmail": "Student Email",
      "startExam": "Start Exam",
      "translate": "Translate to English",
      "translated": "Translated",
      "original": "Original",
      "adminPanel": "Admin Panel",
      "manageTrainers": "Manage Trainers",
      "systemCleanup": "System Cleanup (Admin Only)",
      "cleanAllVideos": "🧹 Clean All Videos",
      "cleanupWarningDesc": "Delete all stored video files. Use before or after deployment.",
      "cleanupSuccess": "All videos cleaned successfully",
      "cleanupFailed": "Cleanup failed",
      "warningTitle": "Important Warning!",
      "cleanupWarning1": "This action will permanently delete ALL stored videos.",
      "cleanupWarning2": "This cannot be undone!",
      "typeToConfirm": "Type the following to confirm:",
      "confirmAction": "Confirm Action",
      "finalConfirmation": "Final Confirmation",
      "areYouSure": "Are you absolutely sure?",
      "yesDelete": "Yes, Delete All",
      "downloadPDF": "Download PDF",
      "downloadCSV": "Download CSV",
      "exportFormat": "Export Format",
      "uploadDocument": "Upload Document (Word/PDF)",
      "extractQuestions": "Extract Questions",
      "reviewQuestions": "Review Extracted Questions",
      "addSelectedQuestions": "Add Selected Questions",
      "selectAll": "Select All",
      "deselectAll": "Deselect All",
      "confirm": "Confirm",
      "continue": "Continue",
      "no": "No",
      "processing": "Processing...",
      "reports": "Reports",
      "reportsDescription": "Generate PDF reports for trainees and instructors",
      "traineeReports": "Trainee Reports",
      "instructorReports": "Instructor Reports",
      "traineeReportDesc": "Select a trainee to generate a PDF report with exam results and attendance",
      "instructorReportDesc": "Select an instructor to generate a PDF report with courses and statistics",
      "selectTrainee": "Select Trainee",
      "selectInstructor": "Select Instructor",
      "downloadReport": "Download Report",
      "reportDownloaded": "Report downloaded successfully",
      "extracted": "Extracted",
      "createLAO": "Create Learning Analytics Officer Account",
      "laoDescription": "Learning Analytics Officer - A role for monitoring, analytics, and reporting only",
      "createLAOAccount": "Create LAO Account",
      "laoCreated": "LAO account created successfully",
      "analyticsOverview": "Analytics Overview",
      "keyPerformanceIndicators": "Key Performance Indicators",
      "topCourses": "Most Requested Courses",
      "activeTrainers": "Most Active Trainers",
      "satisfactionMetrics": "Satisfaction Metrics",
      "platformUsage": "Platform Usage",
      "surveys": "Surveys",
      "createSurvey": "Create Survey",
      "recommendations": "Recommendations & Insights",
      "kpis": "KPIs",
      "overview": "Overview",
      "surveyTitle": "Survey Title",
      "fillSurvey": "Fill Survey",
      "surveySubmitted": "Survey submitted successfully",
      "answerAllQuestions": "Please answer all questions",
      "noSurveysAvailable": "No surveys available at this time",
      "completedSurveys": "Completed Surveys",
      "yourAnswer": "Your answer...",
      "submit": "Submit",
      "surveyCreated": "Survey created and sent",
      "surveyActivated": "Survey activated",
      "surveyHidden": "Survey hidden",
      "surveyDeleted": "Survey deleted",
      "confirmDeleteSurvey": "Are you sure you want to delete this survey?",
      "active": "Active",
      "closed": "Closed",
      "target": "Target",
      "responses": "responses",
      "hide": "Hide",
      "activate": "Activate",
      "report": "Report",
      "addQuestion": "Add Question",
      "question": "Question",
      "rating": "Rating",
      "choice": "Choice",
      "text": "Text",
      "trainees": "Trainees",
      "trainers": "Trainers",
      "allUsers": "All Users",
      "createAndSend": "Create & Send",
      "analyticsReports": "Analytics Reports",
      "analyticsReportDesc": "Generate platform-wide analytics reports",
      "performanceSummary": "Performance Summary",
      "usageAnalysis": "Usage Analysis",
      "identifiedTrends": "Identified Trends",
      "generatePDFReport": "Generate PDF Report",
      "category": "Category",
      "courseType": "Course Type",
      "selectCategory": "Please select category and course type",
      "therapeuticCourses": "Therapeutic Courses",
      "supportingCourses": "Supporting Courses",
      "administrativeCourses": "Administrative & Professional",
      "noContent": "No content available",
      "uploadContentHint": "Click 'Upload Content' to add a new course",
      "recordingVideo": "Recording Video",
      "cameraAccess": "Camera Access",
      "screenRecording": "Screen Recording",
      "allowCamera": "Allow camera and screen recording to continue",
      "recordingStarted": "Recording started successfully",
      "viewRecordings": "View Recordings",
      "examRecordings": "Exam Recordings",
      "cameraVideo": "Camera Video",
      "screenVideo": "Screen Video",
      "downloadVideo": "Download Video",
      "deleteVideo": "Delete Video",
      "videoDeleted": "Video deleted successfully",
      "confirmDelete": "Confirm Delete",
      "deleteVideoConfirmation": "Are you sure you want to delete this video? This action cannot be undone. The exam submission and results will not be affected.",
      "noRecordings": "No recordings available",
      "resultsAnalysis": "Results Analysis",
      "totalSubmissions": "Total Submissions",
      "averageScore": "Average Score",
      "totalStudents": "Total Students",
      "excellent": "Excellent (90-100%)",
      "good": "Good (70-89%)",
      "average": "Average (50-69%)",
      "poor": "Poor (0-49%)",
      "scoreDistribution": "Score Distribution",
      "studentPerformance": "Student Performance",
      "examsTaken": "Exams Taken",
      "watchVideo": "Watch Video",
      "detailedResults": "Detailed Results",
      "playVideo": "Play Video",
      "traineeManagement": "Trainee Management",
      "videoManagement": "Video Management",
      "registeredTrainees": "Registered Trainees",
      "courses": "Courses",
      "myCourses": "My Courses",
      "manageCourseContent": "Manage Course Content",
      "uploadContent": "Upload Content",
      "contentUploaded": "Content uploaded successfully",
      "contentUpdated": "Content updated successfully",
      "contentDeleted": "Content deleted successfully",
      "editContent": "Edit Content",
      "replaceFile": "Replace Content",
      "replaceFileDescription": "Upload a new file to replace the current content (optional)",
      "currentFile": "Current File",
      "newFileSelected": "New file selected",
      "accessGranted": "Access granted successfully",
      "selectStudents": "Select Students",
      "selectStudentsDescription": "Choose students who can access this content",
      "grantAccess": "Grant Access",
      "deleteContentConfirmation": "Are you sure you want to delete this content? The file will be deleted and all student access will be removed.",
      "noContent": "No content available",
      "fileType": "File Type",
      "enterTitle": "Enter title",
      "enterDescription": "Enter description",
      "fillAllFields": "Please fill all fields",
      "uploading": "Uploading...",
      "accessYourCourses": "Access your educational content",
      "noCoursesAvailable": "No content available for you in this course",
      "viewOnlyNote": "You can only view the content. Downloading is not available.",
      "openPowerPoint": "Open PowerPoint",
      "powerPointNote": "The file will open in a new window for viewing",
      "pptViewNote": "If the presentation doesn't display, you can download it to view",
      "downloadToView": "Download to View",
      "pdfConvertedNote": "PowerPoint has been converted to PDF for direct viewing in the platform",
      "pdfViewTip": "Use the + and - buttons in the PDF toolbar to zoom in and out",
      "participationRate": "Participation Rate",
      "attendanceRate": "Attendance Rate",
      "absenceRate": "Absence Rate",
      "updateStats": "Update Stats",
      "myStats": "My Statistics",
      "lastUpdated": "Last Updated",
      "noStats": "No statistics available",
      "statsUpdated": "Statistics updated successfully",
      "trackAttendance": "Track Attendance",
      "trackParticipation": "Track Participation",
      "attendanceTracking": "Attendance Tracking",
      "participationTracking": "Participation Tracking",
      "present": "Present",
      "absent": "Absent",
      "day": "Day",
      "totalParticipations": "Total Participations",
      "maxPossible": "Max Possible",
      "approveResult": "Approve Result",
      "revokeApproval": "Revoke Approval",
      "approved": "Approved",
      "pending": "Pending Approval",
      "resultApproved": "Result approved successfully",
      "approvalRevoked": "Approval revoked successfully",
      "resultsNotApproved": "Results pending teacher approval",
      "waitingForApproval": "Waiting for approval",
      "translating": "Translating...",
      "translateToEnglish": "Translate to English",
      "translateToArabic": "Translate to Arabic",
      "returnToArabic": "Return to Arabic",
      "returnToOriginal": "Return to Original",
      "translatingAllQuestions": "Translating all questions...",
      "translatingToEnglish": "Translating to English...",
      "translatingToArabic": "Translating to Arabic...",
      "translationComplete": "Translation completed successfully",
      "translationFailed": "Translation failed, please try again",
      "returnedToArabic": "Returned to Arabic",
      "returnedToOriginal": "Returned to original language",
      "recordingStarted": "Recording started",
      "recordingFailed": "Recording unavailable, but you can continue",
      "recordingNotice": "Recording Notice",
      "agreeAndStart": "I Agree - Start Exam",
      "continue": "Continue",
      "camera": "Camera",
      "screen": "Screen",
      "startingRecording": "Starting recording...",
      "examStarted": "Exam started successfully",
      "requestingCamera": "Requesting camera access...",
      "requestingScreen": "Requesting screen access...",
      "cameraFailed": "Camera access denied",
      "bothRecordingsStarted": "Camera + Screen recording started",
      "screenRecordingRequired": "Screen recording is required - Access denied",
      "cameraRecordingRequired": "Camera recording is required - Access denied",
      "recordingFailedAccessDenied": "Recording failed - Access denied to exam",
      "publishExam": "Publish Exam",
      "unpublishExam": "Unpublish Exam",
      "published": "Published",
      "unpublished": "Unpublished",
      "examPublished": "Exam published successfully",
      "examUnpublished": "Exam unpublished successfully",
      "editExam": "Edit Exam",
      "examStatus": "Exam Status",
      
      // Results
      "score": "Score",
      "submittedOn": "Submitted On",
      "viewDetails": "View Details",
      "correctAnswers": "Correct Answers",
      "yourAnswer": "Your Answer",
      "backToResults": "Back to Results",
      
      // Stats
      "statistics": "Statistics",
      "categories": "Categories",
      "examCreated": "Exam created successfully!",
      "questionAdded": "Question added successfully!",
      "questionsUploaded": "Questions uploaded successfully!",
      "examSubmitted": "Exam submitted successfully!",
      
      // Messages
      "loading": "Loading...",
      "error": "Error",
      "success": "Success",
      "confirmDelete": "Are you sure you want to delete this?",
      "deleteSuccess": "Deleted successfully",
      "updateSuccess": "Updated successfully",
      
      // Exam Taking
      "question": "Question",
      "of": "of",
      "timeRemaining": "Time Remaining",
      "submitExam": "Submit Exam",
      "examCompleted": "Exam Completed!",
      "examCompletedMessage": "Your exam has been submitted successfully. You can view your results now.",
      
      // Data Management
      "dataManagement": "Data Management",
      "dataManagementDescription": "Delete students, exam results, and videos. Use with caution!",
      "manageStudents": "Manage Trainees",
      "manageResults": "Manage Exam Results",
      "deleteExamWithData": "Delete Exam with All Data",
      "studentDeleted": "Trainee deleted successfully",
      "submissionDeleted": "Result deleted successfully",
      "examDataDeleted": "Exam and all data deleted successfully",
      "confirmDelete": "Confirm Deletion",
      "deleteStudentWarning": "This will permanently delete this trainee and ALL their exam results and videos. This action cannot be undone.",
      "deleteSubmissionWarning": "This will permanently delete this exam result and associated videos. This action cannot be undone.",
      "deleteExamWarning": "This will permanently delete this exam AND ALL student results, videos, and associated data. This action cannot be undone!",
      "dangerZone": "Danger Zone!",
      "deleteAll": "Delete All",
      "deleteEverything": "Delete Everything",
      "showingFirst20": "Showing first 20 results",
      
      // Live Stream
      "liveStream": "Live Stream",
      "manageLiveStreams": "Manage Live Stream Sessions",
      "startNewStream": "Start New Stream",
      "joinActiveStream": "Join Active Stream",
      "liveNow": "Live Now",
      "join": "Join",
      "endStream": "End Stream",
      "streamHistory": "Stream History",
      "active": "Active",
      "students": "Trainees",
      "createLiveStream": "Create Live Stream",
      "title": "Title",
      "description": "Description",
      "enterStreamTitle": "Enter stream title",
      "enterStreamDescription": "Enter stream description",
      "selectStudents": "Select Trainees",
      "deselectAll": "Deselect All",
      "selectAll": "Select All",
      "studentsSelected": "trainees selected",
      "startStream": "Start Stream",
      "streamCreated": "Live stream created",
      "streamEnded": "Stream ended",
      "streamStarted": "Live stream started",
      "backToStream": "Back to Stream",
      "viewers": "viewers",
      "viewStream": "View Stream",
      "fillAllFields": "Please fill all fields",
      "errorAccessingMedia": "Error accessing camera or microphone",
      "screenShareStarted": "Screen sharing started",
      "errorSharingScreen": "Error sharing screen",
      "screenShareStopped": "Screen sharing stopped",
      "noActiveStream": "No active stream available",
      "noStreamMessage": "There is no active live stream currently. You will be notified when the trainer starts a new stream.",
      "startedAt": "Started at",
      "joinStream": "Join Live Stream",
      "connecting": "Connecting...",
      "connected": "Connected",
      "leave": "Leave",
      "connectionError": "Connection error",
      "connectedToStream": "Connected to live stream",
      "errorJoiningStream": "Error joining stream",
      "leftStream": "Left live stream",
      "teacherLeftStream": "Teacher left the stream",
      "connectingToStream": "Connecting to stream...",
      "waitingForStream": "Waiting for stream...",
      "joinedStream": "Joined stream",
      "mute": "Mute",
      "unmute": "Unmute",
      "turnOnVideo": "Turn on video",
      "turnOffVideo": "Turn off video",
      "shareScreen": "Share screen",
      "stopScreenShare": "Stop screen sharing",
      "addStudents": "Add Trainees",
      "addStudentsToStream": "Add Trainees to Stream",
      "selectStudentsToAdd": "Select trainees you want to add to the live stream",
      "addToStream": "Add to Stream",
      "studentsAdded": "Trainees added",
      "pleaseSelectStudents": "Please select trainees",
      "cameraPermissionDenied": "Camera and microphone access denied. Please allow access.",
      "cameraNotFound": "Camera or microphone not found.",
      "refresh": "Refresh",
      "refreshed": "Refreshed",
      "forceEndStream": "Force End Stream",
      "streamCleared": "Stream cleared locally",
      
      // Common
      "back": "Back",
      "next": "Next",
      "previous": "Previous",
      "close": "Close",
      "actions": "Actions",
      "noData": "No data available"
    }
  },
  ar: {
    translation: {
      // Auth
      "login": "تسجيل الدخول",
      "register": "التسجيل",
      "email": "البريد الإلكتروني",
      "password": "كلمة المرور",
      "name": "الاسم",
      "role": "الدور",
      "teacher": "مدرب",
      "student": "متدرب",
      "logout": "تسجيل الخروج",
      "welcomeBack": "مرحباً بعودتك",
      "createAccount": "إنشاء حساب",
      "alreadyHaveAccount": "لديك حساب بالفعل؟",
      "dontHaveAccount": "ليس لديك حساب؟",
      
      // Dashboard
      "dashboard": "لوحة التحكم",
      "questionBank": "بنك الأسئلة",
      "exams": "الاختبارات",
      "myExams": "اختباراتي",
      "results": "النتائج",
      "myResults": "نتائجي",
      
      // Questions
      "addQuestion": "إضافة سؤال",
      "uploadQuestions": "رفع الأسئلة",
      "questionText": "نص السؤال",
      "optionA": "الخيار أ",
      "optionB": "الخيار ب",
      "optionC": "الخيار ج",
      "optionD": "الخيار د",
      "correctAnswer": "الإجابة الصحيحة",
      "category": "التصنيف",
      "difficulty": "الصعوبة",
      "easy": "سهل",
      "medium": "متوسط",
      "hard": "صعب",
      "save": "حفظ",
      "cancel": "إلغاء",
      "edit": "تعديل",
      "delete": "حذف",
      "search": "بحث",
      "filter": "تصفية",
      "totalQuestions": "إجمالي الأسئلة",
      "uploadFile": "رفع ملف",
      "dragDropFile": "اسحب وأفلت الملف هنا، أو انقر للاختيار",
      "supportsExcelCSV": "يدعم ملفات Excel (.xlsx, .xls) و CSV",
      
      // Exams
      "createExam": "إنشاء اختبار",
      "examTitle": "عنوان الاختبار",
      "duration": "المدة (بالدقائق)",
      "generateExam": "إنشاء الاختبار",
      "takeExam": "بدء الاختبار",
      "viewResults": "عرض النتائج",
      "submit": "إرسال",
      "examsList": "قائمة الاختبارات",
      "availableExams": "الاختبارات المتاحة",
      "noExamsAvailable": "لا توجد اختبارات متاحة",
      "questionsCount": "أسئلة",
      "minutes": "دقائق",
      "numberOfQuestions": "عدد الأسئلة",
      "editExam": "تعديل الاختبار",
      "examUpdated": "تم تحديث الاختبار بنجاح",
      "downloadPDF": "تحميل PDF",
      "pdfDownloaded": "تم تحميل PDF بنجاح",
      "editQuestions": "تعديل الأسئلة",
      "saveChanges": "حفظ التغييرات",
      "noExamsAvailable": "لا توجد اختبارات متاحة",
      "questionsCount": "سؤال",
      "minutes": "دقيقة",
      "numberOfQuestions": "عدد الأسئلة",
      "appName": "شمعة",
      "appFullName": "منصة شمعة للاختبارات",
      "addTrainer": "إضافة مدرب",
      "exportData": "تصدير البيانات",
      "downloadSubmissions": "تحميل النتائج",
      "downloadPendingExams": "تحميل الاختبارات المعلقة",
      "studentName": "اسم المتدرب",
      "studentEmail": "البريد الإلكتروني للمتدرب",
      "startExam": "بدء الاختبار",
      "translate": "ترجمة للإنجليزية",
      "translated": "مترجم",
      "original": "أصلي",
      "adminPanel": "لوحة الإدارة",
      "manageTrainers": "إدارة المدربين",
      "systemCleanup": "تنظيف النظام (مدير فقط)",
      "cleanAllVideos": "🧹 تنظيف جميع الفيديوهات",
      "cleanupWarningDesc": "حذف جميع ملفات الفيديو المخزنة. استخدم قبل أو بعد النشر.",
      "cleanupSuccess": "تم تنظيف جميع الفيديوهات بنجاح",
      "cleanupFailed": "فشل التنظيف",
      "warningTitle": "تحذير هام!",
      "cleanupWarning1": "هذا الإجراء سيحذف جميع ملفات الفيديو المخزنة نهائياً.",
      "cleanupWarning2": "لا يمكن التراجع عن هذا الإجراء!",
      "typeToConfirm": "اكتب النص التالي للتأكيد:",
      "confirmAction": "تأكيد الإجراء",
      "finalConfirmation": "التأكيد النهائي",
      "areYouSure": "هل أنت متأكد تماماً؟",
      "yesDelete": "نعم، احذف الكل",
      "downloadPDF": "تحميل PDF",
      "downloadCSV": "تحميل CSV",
      "exportFormat": "تنسيق التصدير",
      "uploadDocument": "رفع مستند (Word/PDF)",
      "extractQuestions": "استخراج الأسئلة",
      "reviewQuestions": "مراجعة الأسئلة المستخرجة",
      "addSelectedQuestions": "إضافة الأسئلة المحددة",
      "selectAll": "تحديد الكل",
      "deselectAll": "إلغاء التحديد",
      "confirm": "تأكيد",
      "continue": "متابعة",
      "no": "لا",
      "processing": "جاري التنفيذ...",
      "reports": "التقارير",
      "reportsDescription": "إنشاء تقارير PDF للمتدربين والمدربين",
      "traineeReports": "تقارير المتدربين",
      "instructorReports": "تقارير المدربين",
      "traineeReportDesc": "اختر متدرب لإنشاء تقرير PDF يتضمن نتائج الاختبارات ونسب الحضور والمشاركة",
      "instructorReportDesc": "اختر مدرب لإنشاء تقرير PDF يتضمن الدورات والإحصائيات",
      "selectTrainee": "اختر متدرب",
      "selectInstructor": "اختر مدرب",
      "downloadReport": "تحميل التقرير",
      "reportDownloaded": "تم تحميل التقرير بنجاح",
      "extracted": "مستخرج",
      "createLAO": "إنشاء حساب مسؤول تحليلات التعلم",
      "laoDescription": "Learning Analytics Officer - دور للمراقبة والتحليل وإعداد التقارير فقط",
      "createLAOAccount": "إنشاء حساب LAO",
      "laoCreated": "تم إنشاء حساب LAO بنجاح",
      "analyticsOverview": "نظرة عامة على التحليلات",
      "keyPerformanceIndicators": "مؤشرات الأداء الرئيسية",
      "topCourses": "الدورات الأكثر طلباً",
      "activeTrainers": "المدربون الأكثر نشاطاً",
      "satisfactionMetrics": "مقاييس الرضا",
      "platformUsage": "استخدام المنصة",
      "surveys": "الاستبيانات",
      "createSurvey": "إنشاء استبيان",
      "recommendations": "التوصيات والرؤى",
      "kpis": "مؤشرات الأداء",
      "overview": "نظرة عامة",
      "surveyTitle": "عنوان الاستبيان",
      "fillSurvey": "ملء الاستبيان",
      "surveySubmitted": "تم إرسال الاستبيان بنجاح",
      "answerAllQuestions": "يرجى الإجابة على جميع الأسئلة",
      "noSurveysAvailable": "لا توجد استبيانات متاحة حالياً",
      "completedSurveys": "الاستبيانات المكتملة",
      "yourAnswer": "إجابتك...",
      "submit": "إرسال",
      "surveyCreated": "تم إنشاء الاستبيان وإرساله",
      "surveyActivated": "تم تفعيل الاستبيان",
      "surveyHidden": "تم إخفاء الاستبيان",
      "surveyDeleted": "تم حذف الاستبيان",
      "confirmDeleteSurvey": "هل أنت متأكد من حذف هذا الاستبيان؟",
      "active": "نشط",
      "closed": "مغلق",
      "target": "الفئة المستهدفة",
      "responses": "ردود",
      "hide": "إخفاء",
      "activate": "تفعيل",
      "report": "تقرير",
      "addQuestion": "إضافة سؤال",
      "question": "السؤال",
      "rating": "تقييم",
      "choice": "اختيار",
      "text": "نص",
      "trainees": "المتدربين",
      "trainers": "المدربين",
      "allUsers": "جميع المستخدمين",
      "createAndSend": "إنشاء وإرسال",
      "analyticsReports": "تقارير التحليلات",
      "analyticsReportDesc": "إنشاء تقارير تحليلية على مستوى المنصة",
      "performanceSummary": "ملخص الأداء",
      "usageAnalysis": "تحليل الاستخدام",
      "identifiedTrends": "الاتجاهات المحددة",
      "generatePDFReport": "إنشاء تقرير PDF",
      "category": "التصنيف",
      "courseType": "نوع الدورة",
      "selectCategory": "يرجى اختيار التصنيف ونوع الدورة",
      "therapeuticCourses": "الدورات العلاجية",
      "supportingCourses": "الدورات الداعمة",
      "administrativeCourses": "الدورات الإدارية والمهنية",
      "noContent": "لا يوجد محتوى",
      "uploadContentHint": "اضغط على 'رفع محتوى' لإضافة دورة جديدة",
      "recordingVideo": "تسجيل الفيديو",
      "cameraAccess": "الوصول للكاميرا",
      "screenRecording": "تسجيل الشاشة",
      "allowCamera": "السماح بتسجيل الكاميرا والشاشة للمتابعة",
      "recordingStarted": "بدأ التسجيل بنجاح",
      "viewRecordings": "عرض التسجيلات",
      "examRecordings": "تسجيلات الاختبارات",
      "cameraVideo": "فيديو الكاميرا",
      "screenVideo": "فيديو الشاشة",
      "downloadVideo": "تحميل الفيديو",
      "deleteVideo": "حذف الفيديو",
      "videoDeleted": "تم حذف الفيديو بنجاح",
      "confirmDelete": "تأكيد الحذف",
      "deleteVideoConfirmation": "هل أنت متأكد من حذف هذا الفيديو؟ لا يمكن التراجع عن هذا الإجراء. لن يتأثر الاختبار والنتائج.",
      "noRecordings": "لا توجد تسجيلات متاحة",
      "resultsAnalysis": "تحليل النتائج",
      "totalSubmissions": "إجمالي التقديمات",
      "averageScore": "متوسط الدرجات",
      "totalStudents": "إجمالي المتدربين",
      "excellent": "ممتاز (90-100%)",
      "good": "جيد (70-89%)",
      "average": "متوسط (50-69%)",
      "poor": "ضعيف (0-49%)",
      "scoreDistribution": "توزيع الدرجات",
      "studentPerformance": "أداء المتدربين",
      "examsTaken": "الاختبارات المنجزة",
      "watchVideo": "مشاهدة الفيديو",
      "detailedResults": "النتائج التفصيلية",
      "playVideo": "تشغيل الفيديو",
      "traineeManagement": "إدارة المتدربين",
      "videoManagement": "إدارة الفيديوهات",
      "registeredTrainees": "المتدربين المسجلين",
      "courses": "الدورات",
      "myCourses": "دوراتي",
      "manageCourseContent": "إدارة محتوى الدورات",
      "uploadContent": "رفع محتوى",
      "contentUploaded": "تم رفع المحتوى بنجاح",
      "contentUpdated": "تم تحديث المحتوى بنجاح",
      "contentDeleted": "تم حذف المحتوى بنجاح",
      "editContent": "تعديل المحتوى",
      "replaceFile": "استبدال المحتوى",
      "replaceFileDescription": "ارفع ملف جديد لاستبدال المحتوى الحالي (اختياري)",
      "currentFile": "الملف الحالي",
      "newFileSelected": "تم اختيار ملف جديد",
      "accessGranted": "تم منح الصلاحية بنجاح",
      "selectStudents": "اختيار الطلاب",
      "selectStudentsDescription": "اختر الطلاب المسموح لهم بالوصول إلى هذا المحتوى",
      "grantAccess": "منح الصلاحية",
      "deleteContentConfirmation": "هل أنت متأكد من حذف هذا المحتوى؟ سيتم حذف الملف وإزالة الصلاحيات من جميع الطلاب.",
      "noContent": "لا يوجد محتوى",
      "fileType": "نوع الملف",
      "enterTitle": "أدخل العنوان",
      "enterDescription": "أدخل الوصف",
      "fillAllFields": "يرجى ملء جميع الحقول",
      "uploading": "جاري الرفع...",
      "accessYourCourses": "الوصول إلى المحتوى التعليمي الخاص بك",
      "noCoursesAvailable": "لا يوجد محتوى متاح لك في هذه الدورة",
      "viewOnlyNote": "يمكنك مشاهدة المحتوى فقط. التحميل غير متاح.",
      "openPowerPoint": "فتح PowerPoint",
      "powerPointNote": "سيتم فتح الملف في نافذة جديدة للعرض",
      "pptViewNote": "إذا لم يظهر العرض التقديمي، يمكنك تحميله ومشاهدته",
      "downloadToView": "تحميل للمشاهدة",
      "pdfConvertedNote": "تم تحويل العرض التقديمي إلى PDF للعرض المباشر في المنصة",
      "pdfViewTip": "استخدم أزرار + و - في شريط أدوات PDF للتكبير والتصغير",
      "participationRate": "نسبة المشاركة",
      "attendanceRate": "نسبة الحضور",
      "absenceRate": "نسبة الغياب",
      "updateStats": "تحديث الإحصائيات",
      "myStats": "إحصائياتي",
      "lastUpdated": "آخر تحديث",
      "noStats": "لا توجد إحصائيات متاحة",
      "statsUpdated": "تم تحديث الإحصائيات بنجاح",
      "trackAttendance": "تتبع الحضور",
      "trackParticipation": "تتبع المشاركة",
      "attendanceTracking": "تتبع الحضور",
      "participationTracking": "تتبع المشاركة",
      "present": "حاضر",
      "absent": "غائب",
      "day": "اليوم",
      "totalParticipations": "إجمالي المشاركات",
      "maxPossible": "الحد الأقصى الممكن",
      "approveResult": "الموافقة على النتيجة",
      "revokeApproval": "إلغاء الموافقة",
      "approved": "معتمد",
      "pending": "في انتظار الموافقة",
      "resultApproved": "تم اعتماد النتيجة بنجاح",
      "approvalRevoked": "تم إلغاء الموافقة بنجاح",
      "resultsNotApproved": "النتائج في انتظار موافقة المدرب",
      "waitingForApproval": "في انتظار الموافقة",
      "translating": "جاري الترجمة...",
      "translateToEnglish": "ترجمة إلى الإنجليزية",
      "translateToArabic": "ترجمة إلى العربية",
      "returnToArabic": "العودة إلى العربية",
      "returnToOriginal": "العودة إلى اللغة الأصلية",
      "translatingAllQuestions": "جاري ترجمة جميع الأسئلة...",
      "translatingToEnglish": "جاري الترجمة إلى الإنجليزية...",
      "translatingToArabic": "جاري الترجمة إلى العربية...",
      "translationComplete": "تمت الترجمة بنجاح",
      "translationFailed": "فشلت الترجمة، يرجى المحاولة مرة أخرى",
      "returnedToArabic": "تم العودة إلى العربية",
      "returnedToOriginal": "تم العودة إلى اللغة الأصلية",
      "returnedToArabic": "تم العودة إلى العربية",
      "recordingStarted": "بدأ التسجيل",
      "recordingFailed": "التسجيل غير متاح، لكن يمكنك المتابعة",
      "recordingNotice": "إشعار التسجيل",
      "agreeAndStart": "أوافق - بدء الاختبار",
      "continue": "متابعة",
      "camera": "الكاميرا",
      "screen": "الشاشة",
      "startingRecording": "جاري بدء التسجيل...",
      "examStarted": "بدأ الاختبار بنجاح",
      "requestingCamera": "طلب الوصول للكاميرا...",
      "requestingScreen": "طلب الوصول للشاشة...",
      "cameraFailed": "تم رفض الوصول للكاميرا",
      "bothRecordingsStarted": "بدأ تسجيل الكاميرا + الشاشة",
      "screenRecordingRequired": "تسجيل الشاشة مطلوب - دخول غير مسموح",
      "cameraRecordingRequired": "تسجيل الكاميرا مطلوب - دخول غير مسموح",
      "recordingFailedAccessDenied": "فشل التسجيل - دخول غير مسموح للاختبار",
      "publishExam": "نشر الاختبار",
      "unpublishExam": "إلغاء النشر",
      "published": "منشور",
      "unpublished": "غير منشور",
      "examPublished": "تم نشر الاختبار بنجاح",
      "examUnpublished": "تم إلغاء نشر الاختبار بنجاح",
      "editExam": "تعديل الاختبار",
      "examStatus": "حالة الاختبار",
      
      // Results
      "score": "الدرجة",
      "submittedOn": "تم التقديم في",
      "viewDetails": "عرض التفاصيل",
      "correctAnswers": "الإجابات الصحيحة",
      "yourAnswer": "إجابتك",
      "backToResults": "العودة للنتائج",
      
      // Stats
      "statistics": "الإحصائيات",
      "categories": "التصنيفات",
      "examCreated": "تم إنشاء الاختبار بنجاح!",
      "questionAdded": "تم إضافة السؤال بنجاح!",
      "questionsUploaded": "تم رفع الأسئلة بنجاح!",
      "examSubmitted": "تم تقديم الاختبار بنجاح!",
      
      // Messages
      "loading": "جارٍ التحميل...",
      "error": "خطأ",
      "success": "نجح",
      "confirmDelete": "هل أنت متأكد من الحذف؟",
      "deleteSuccess": "تم الحذف بنجاح",
      "updateSuccess": "تم التحديث بنجاح",
      
      // Exam Taking
      "question": "السؤال",
      "of": "من",
      "timeRemaining": "الوقت المتبقي",
      "submitExam": "تسليم الاختبار",
      "examCompleted": "تم إكمال الاختبار!",
      "examCompletedMessage": "تم تقديم اختبارك بنجاح. يمكنك الآن عرض نتائجك.",
      
      // Data Management
      "dataManagement": "إدارة البيانات",
      "dataManagementDescription": "حذف المتدربين ونتائج الاختبارات والفيديوهات. استخدم بحذر!",
      "manageStudents": "إدارة المتدربين",
      "manageResults": "إدارة نتائج الاختبارات",
      "deleteExamWithData": "حذف الاختبار مع جميع البيانات",
      "studentDeleted": "تم حذف المتدرب بنجاح",
      "submissionDeleted": "تم حذف النتيجة بنجاح",
      "examDataDeleted": "تم حذف الاختبار وجميع البيانات بنجاح",
      "confirmDelete": "تأكيد الحذف",
      "deleteStudentWarning": "سيؤدي هذا إلى حذف المتدرب نهائياً وجميع نتائج اختباراته وفيديوهاته. لا يمكن التراجع عن هذا الإجراء.",
      "deleteSubmissionWarning": "سيؤدي هذا إلى حذف نتيجة الاختبار والفيديوهات المرتبطة بها نهائياً. لا يمكن التراجع عن هذا الإجراء.",
      "deleteExamWarning": "سيؤدي هذا إلى حذف الاختبار وجميع نتائج الطلاب والفيديوهات والبيانات المرتبطة به نهائياً. لا يمكن التراجع عن هذا الإجراء!",
      "dangerZone": "منطقة خطر!",
      "deleteAll": "حذف الكل",
      "deleteEverything": "حذف كل شيء",
      "showingFirst20": "عرض أول 20 نتيجة",
      
      // Live Stream
      "liveStream": "البث المباشر",
      "manageLiveStreams": "إدارة جلسات البث المباشر",
      "startNewStream": "بدء بث جديد",
      "joinActiveStream": "الانضمام للبث النشط",
      "liveNow": "مباشر الآن",
      "join": "انضم",
      "endStream": "إنهاء البث",
      "streamHistory": "سجل البث",
      "active": "نشط",
      "students": "متدربين",
      "createLiveStream": "إنشاء بث مباشر",
      "title": "العنوان",
      "description": "الوصف",
      "enterStreamTitle": "أدخل عنوان البث",
      "enterStreamDescription": "أدخل وصف البث",
      "selectStudents": "اختر المتدربين",
      "deselectAll": "إلغاء تحديد الكل",
      "selectAll": "تحديد الكل",
      "studentsSelected": "متدرب محدد",
      "startStream": "بدء البث",
      "streamCreated": "تم إنشاء البث المباشر",
      "streamEnded": "تم إنهاء البث",
      "streamStarted": "بدأ البث المباشر",
      "backToStream": "العودة للبث",
      "viewers": "مشاهد",
      "viewStream": "عرض البث",
      "fillAllFields": "يرجى ملء جميع الحقول",
      "errorAccessingMedia": "خطأ في الوصول للكاميرا أو الميكروفون",
      "screenShareStarted": "بدأت مشاركة الشاشة",
      "errorSharingScreen": "خطأ في مشاركة الشاشة",
      "screenShareStopped": "توقفت مشاركة الشاشة",
      "noActiveStream": "لا يوجد بث مباشر متاح",
      "noStreamMessage": "لا يوجد بث مباشر نشط حالياً. سيتم إعلامك عند بدء المدرب بث جديد.",
      "startedAt": "بدأ في",
      "joinStream": "الانضمام للبث المباشر",
      "connecting": "جاري الاتصال...",
      "connected": "متصل",
      "leave": "مغادرة",
      "connectionError": "خطأ في الاتصال",
      "connectedToStream": "متصل بالبث المباشر",
      "errorJoiningStream": "خطأ في الانضمام للبث",
      "leftStream": "غادرت البث المباشر",
      "teacherLeftStream": "غادر المعلم البث",
      "connectingToStream": "جاري الاتصال بالبث...",
      "waitingForStream": "في انتظار البث...",
      "joinedStream": "انضممت للبث",
      "mute": "كتم الصوت",
      "unmute": "إلغاء كتم الصوت",
      "turnOnVideo": "تشغيل الفيديو",
      "turnOffVideo": "إيقاف الفيديو",
      "shareScreen": "مشاركة الشاشة",
      "stopScreenShare": "إيقاف مشاركة الشاشة",
      "addStudents": "إضافة متدربين",
      "addStudentsToStream": "إضافة متدربين للبث",
      "selectStudentsToAdd": "اختر المتدربين الذين تريد إضافتهم للبث المباشر",
      "addToStream": "إضافة للبث",
      "studentsAdded": "تم إضافة المتدربين",
      "pleaseSelectStudents": "يرجى اختيار متدربين",
      "cameraPermissionDenied": "تم رفض الوصول للكاميرا والميكروفون. يرجى السماح بالوصول.",
      "cameraNotFound": "لم يتم العثور على كاميرا أو ميكروفون.",
      "refresh": "تحديث",
      "refreshed": "تم التحديث",
      "forceEndStream": "إنهاء البث بالقوة",
      "streamCleared": "تم مسح البث المحلي",
      
      // Common
      "back": "رجوع",
      "next": "التالي",
      "previous": "السابق",
      "close": "إغلاق",
      "actions": "الإجراءات",
      "noData": "لا توجد بيانات"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ar', // Default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;